/**
 * component/privacypolicy/index
 */

import React from 'react';
import Grid from 'material-ui/Grid';
import Helmet from "../Helmet";
import PAGE_CONFIG from '../../config/privacy_policy.json';
import { Link } from 'react-router-dom';
import { initGA } from '../GA'; 

class PrivacyPolicy extends React.Component{
  
  componentDidMount(){
    initGA();
  }
  
  render(){
    return (
      <div className="center-container">
        <Helmet title={PAGE_CONFIG.title} description={PAGE_CONFIG.description} canonical={PAGE_CONFIG.canonical} />
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <div className="contents-title-cont">
                <h1 className="contents-title">{PAGE_CONFIG.title}</h1>
                <p className="contents-sub-title">{PAGE_CONFIG.sub_title}</p>
              </div>
              <div className="middle-container">
                <p className="pp-lead-text">株式会社JLN（以下、弊社）は、お客様からお預かりした氏名・住所・電話番号のような、個人を特定しうる情報（以下、個人情報）を尊重し、誠意を持って慎重かつ適正に取り扱います。個人情報の保護を責務とし個人情報保護方針を以下のように定めます。</p>
                <dl className="pp-dl">
                  <dt className="pp-dt">個人情報の利用目的</dt>
                  <dd className="pp-dd">弊社が収集するお客様の個人情報は、以下の目的のため利用します。
                  <h4>利用対象となる事業</h4>
                  <ul className="pp-ul">
                    <li className="pp-li">Webサイト制作事業</li>
                    <li className="pp-li">従業員採用</li>
                  </ul>
                  <h4>個人情報利用・収集の理由</h4>
                  <ul className="pp-ul">
                    <li className="pp-li">弊社サービスをご利用のお客様に対するサポート、情報提供を行う為。</li>
                    <li className="pp-li">お客様にサービスをご利用頂くための必要最低限な個人情報の取得の為。</li>
                    <li className="pp-li">各種制作事業の依頼を請けた時の、お客様とのお取引きを適切かつ円滑に履行する為。</li>
                  </ul>
                  </dd>
                  <dt className="pp-dt">個人情報の情報管理体制</dt>
                  <dd className="pp-dd">弊社は、個人情報への不正アクセスや個人情報の紛失・改ざん・漏洩といった問題から保護し、正確性及び安全性を確保するために管理体制を整備し、適切な安全対策を実施します。</dd>
                  <dt className="pp-dt">第三者提供の制限・開示</dt>
                  <dd className="pp-dd">
                    弊社は、ご利用者の個人情報を、ご利用者の同意を得ることなく業務委託先以外の第三者に開示することはありません。ただし、以下の場合を除きます。
                    <ul className="pp-ul">
                    <li className="pp-li">お客様の同意がある場合</li>
                    <li className="pp-li">キャンペーンやイベントへの応募などで業務を代理店・運送業者・決済業者などに委託する場合</li>
                    <li className="pp-li">法令などにより、個人情報の提供を求められた場合</li>
                  </ul>
                  </dd>
                  <dt className="pp-dt">個人情報の正確性</dt>
                  <dd className="pp-dd">弊社保有の個人情報について、ご本人様(または代理人様)からの自己の個人情報の開示・訂正・追加・削除または利用の停止を希望される場合は、下記お問合せ窓口よりご連絡ください。個人情報をご提供いただきましたご本人様であることを確認した後、社会通念や慣行に照らし合理的な範囲内ですみやかに対応いたします。</dd>
                  <dt className="pp-dt">お客様のアクセスログについて</dt>
                  <dd className="pp-dd">当サイトでは、アクセスされた方の情報をアクセスログという形で記録しています。アクセスログには、アクセスされた方のドメイン名やIPアドレス、使用しているブラウザの種類、アクセス日時などが含まれますが、アクセスログは、Webサイトの保守管理や利用状況に関する統計・分析のために活用され、それ以外の目的で利用されることはありません。</dd>
                  <dt className="pp-dt">Cookieについて</dt>
                  <dd className="pp-dd">
                  当サイトでは、操作性と利便性を向上するために多くのサイトで標準的に使われている「Cookie」を利用しています。「Cookie」とは、 webサイトを利用するお客様の情報をコンピューター上で記録し、管理する技術のことをいいます。Cookieを使用することにより、頻繁に利用されるサービスについて操作を簡略化できます。これらはお客様がサイトに再度訪問された際、より便利にサイトを閲覧していただくためのものであり、個人のプライバシーを侵害するものではなく、コンピューターへ悪影響を及ぼすこともありません。<br />また、お客様はご自身のブラウザの設定を変更することにより、事前にそのCookieを受け取るかどうかを選択することもできます。
                  </dd>
                  <dt className="pp-dt">お問合せ窓口</dt>
                  <dd className="pp-dd">個人情報等の取扱いについてお客様に十分なご理解をいただくことはたいへん重要です。上記内容についてのご意見・ご質問がございましたら、下記までご連絡くださいますようお願いいたします。
                  <address>株式会社JLN<br />
                      〒231-0058<br />
                      神奈川県横浜市中区弥生町2-15-1 ストークタワーIII 503<br />
                      個人情報管理責任者<br />
                      <br />
                      <Link to='/contact/'>お問い合わせ</Link>
                  </address>
                  </dd>
                </dl>
              </div>
            </Grid>
          </Grid>
        </div>
    )
  }
}

export default PrivacyPolicy



// WEBPACK FOOTER //
// ./src/component/privacypolicy/index.js